'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
    // Loan Applications
    async getLoanApplications() {
        const data = {
            method: 'get',
            url: 'loans',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },

    async submitLoanApplication(json) {
        const data = {
            method: 'post',
            url: 'loan',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Loan application submitted successfully')
            return true
        }
    },

    async addGuarantor(json) {
        const data = {
            method: 'post',
            url: 'loan/' + json.loan_id + '/guarantor',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Guarantor added successfully');
            return true
        }
    },

    async approveLoanApplication(id, json) {
        const data = {
            method: 'patch',
            url: 'loan/' + id + '/approve',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Loan application approved successfully')
            return true
        }
    },

    async rejectLoanApplication(id, json) {
        const data = {
            method: 'patch',
            url: 'loan/' + id + '/reject',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Loan application rejected successfully')
            return true
        }
    },

    async approveGuarantor(id) {
        const data = {
            method: 'patch',
            url: 'loan-guarantor/' + id + '/approve',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Guarantor request approved successfully')
            return response.data
        }
    },

    async rejectGuarantor(id, json) {
        const data = {
            method: 'patch',
            url: 'loan-guarantor/' + id + '/reject',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Guarantor request rejected successfully')
            return response.data
        }
    },

    // Get a single loan application by ID
    async getLoanApplication(id) {
        const data = {
            method: 'get',
            url: 'loan/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },

    // Get loan applications for the current user
    async getMyLoanApplications() {
        const data = {
            method: 'get',
            url: 'loans',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },

    // Get guarantor requests for the current user
    async getMyGuarantorRequests(id) {
        const data = {
            method: 'get',
            url: 'loan-guarantor/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },

    async generateLoanQuotation(json) {
        const data = {
            method: 'post',
            url: 'generate-quotation',
            body: json
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    }
}
